import React from 'react';

const IconBookmark = ({ size = 24, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size} // optional size
    height={size} // optional size
    fill={color} // optional fill color
    stroke={color} // optional stroke color
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round">
    <title>Bookmark</title>
    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
  </svg>
);

export default IconBookmark;
